//import Libraries
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
//import Components
import {Button, Row, Col, Form, FormGroup, Label, Input} from 'reactstrap'

import ImageSelector from '../../ImageSelector/ImageSelector';
import EditConfirmButton from '../../EditConfirmButton/EditConfirmButton';
import UpDownButton from '../../UpDownButton/UpDownButton';

//import Styles
import './AdminOrderableFormLine.css'
import * as homepageActions from '../../../HomepageManager/actions/homepageActions';

class AdminOrderableFormLine extends Component {

    constructor(props) {
        super(props);

        const { title, content } = props.data;

        this.state = {
            koTitle : title['ko'],
            koContent : content['ko'],
            enTitle : title['en'],
            enContent : content['en'],
        }
    }

    componentDidUpdate(prevProps, prevState, snapshow) {
        if(prevProps.editing && !this.props.editing) {
            const { title, content } = this.props.data;
            this.setState({
                koTitle: title['ko'],
                koContent: content['ko'],
                enTitle: title['en'],
                enContent: content['en'],
            })
        }

        if (prevProps.data.title !== this.props.data.title ||
            prevProps.data.content !== this.props.data.content) {
            const { title, content } = this.props.data;
            this.setState({
                koTitle: title["ko"],
                koContent: content["ko"],
                enTitle: title["en"],
                enContent: content["en"]
            });
        }
    }

    handleOnChange = (e) => {
        this.setState({
            [e.target.name] : e.target.value
        })
    }

    toggleEditing = () => {
        const { id, title, content } = this.props.data;
        this.props.askCancleEditing(() => {
            this.setState(prevState => ({
                koTitle: title["ko"],
                koContent: content["ko"],
                enTitle: title["en"],
                enContent: content["en"]
            }))
            this.props.toggleEditing(id);
        }, id)
    }

    render(){
        const {koTitle, koContent, enTitle, enContent} = this.state;
        const {editing, editAnything, index} = this.props;
        return (
            <div className="sub-category">
                <Row>
                    <div className="IndexLabel">{index + 1}</div>
                    <div className="ImageSelector">
                        <ImageSelector 
                            storagePath={this.props.storagePath}
                            imageId={this.props.data.id}
                        />
                    </div>
                    <Col>
                        <Form>
                            <FormGroup>
                                <Label className="mr-sm-2">제목</Label>
                                <Input
                                    type="text"
                                    name="koTitle"
                                    value={koTitle}
                                    onChange={this.handleOnChange}
                                    disabled={!editing}
                                    bsSize="sm"
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label className="mr-sm-2">내용</Label>
                                <Input
                                    type="textarea"
                                    name="koContent"
                                    value={koContent}
                                    onChange={this.handleOnChange}
                                    disabled={!editing}
                                    bsSize="sm"
                                />
                            </FormGroup>
                        </Form>
                    </Col>
                    <Col>
                        <Form>
                            <FormGroup>
                                <Label className="mr-sm-2">Title</Label>
                                <Input
                                    type="text"
                                    name="enTitle"
                                    value={enTitle}
                                    onChange={this.handleOnChange}
                                    disabled={!editing}
                                    bsSize="sm"
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label className="mr-sm-2">Content</Label>
                                <Input
                                    type="textarea"
                                    name="enContent"
                                    value={enContent}
                                    onChange={this.handleOnChange}
                                    disabled={!editing}
                                    bsSize="sm"
                                />
                            </FormGroup>
                        </Form>
                    </Col>
                    <Col sm={1}>
                        <UpDownButton
                            disabled={this.props.editAnything}
                            onOrderUp={() => {
                                this.props.onHomepageDataOrderSwitch(this.props.dbPath, index, index - 1);
                            }}
                            onOrderDown={() => {
                                this.props.onHomepageDataOrderSwitch(this.props.dbPath, index, index + 1);
                            }}
                        />
                        <EditConfirmButton 
                            editing={editing}
                            onConfirm={ () => {
                                this.props.onUpdateData(
                                    this.props.dbPath,
                                    this.props.data.id, {
                                        en : this.state.enTitle,
                                        ko : this.state.koTitle
                                    }, {
                                        en : this.state.enContent,
                                        ko : this.state.koContent
                                    })
                            }}
                            onToggleEditing={this.toggleEditing}
                            onRemove={() => {
                                this.props.onRemoveData(
                                    this.props.dbPath,
                                    this.props.storagePath,
                                    this.props.data.id);
                            }}
                        />
                    </Col>
                </Row>

            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onHomepageDataOrderSwitch : (dbPath, aIndex, bIndex) => {
            dispatch(homepageActions.homepageDataOrderSwitch(dbPath, aIndex, bIndex))
        },
        onUpdateData : (dbPath, id, title, content) => {
            dispatch(homepageActions.updateHomepageData(dbPath, id, title, content));
        },
        onRemoveData : (dbPath, storagePath, id) => {
            dispatch(homepageActions.removeHomepageData(dbPath, storagePath, id));
        }
    }
}

export default connect(null, mapDispatchToProps)(AdminOrderableFormLine);

// AdminOrderableFormLine.propTypes = {
//     data : PropTypes.object.isRequired,
//     onUpdate : PropTypes.func.isRequired,
//     onRemove : PropTypes.func.isRequired,
//     storagePath : PropTypes.string.isRequired,
// }

// AdminOrderableFormLine.defaultProps = {
//     onUpdate : null,
//     onRemove : null,
//     onOrderUp : null,
//     onOrderDown : null,
// }


// WEBPACK FOOTER //
// ./src/pages/Admin/Components/AdminOrderableFormManager/FormLines/AdminOrderableFormLine.js